<script setup lang="ts">
import { type PropType, reactive, watch } from 'vue'
import type { ObjectInventoryField } from '@/entities/Inventory/ObjectTypes'
import { PeriodUpdateList, TriggerUpdateList } from './../../model/types.ts'

const props = defineProps({
  field: {
    type: Object as PropType<ObjectInventoryField>,
    required: true,
  },
})

const emits = defineEmits(['update'])

const currentValues = reactive({
  prefix_interator: props.field?.prefix_interator || '',
  period_update: props.field?.period_update || 'DAILY',
  trigger_update: props.field?.trigger_update || 'ALL',
})

/** Обновляем данные поля */
watch(currentValues, () => {
  emits('update', { ...props.field, ...currentValues })
})
</script>

<template>
  <VTextField
    v-model="currentValues.prefix_interator"
    :label="$t('itf.prefix_field')"
    suffix="-{YYYY}-{MM}-{dd}-{N}"
  />

  <VSelect
    v-model="currentValues.period_update"
    :items="PeriodUpdateList"
    :label="$t('itf.period_update')"
  />

  <VSelect
    v-model="currentValues.trigger_update"
    :items="TriggerUpdateList"
    :label="$t('itf.trigger_update')"
  />
</template>
